'use client';

import GalleryItem from '@/components/Gallery/item';
import useIsMobile from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import Slider from 'react-slick';
import classes from './relatedProducts.module.css';

const RelatedProducts = props => {
  const { slidesToShow, hideProductName = false, showCustomizeOptions = false, classNames = {} } = props;

  const isMobile = useIsMobile();
  const { products } = props;

  return (
    <div
      className={clsx(
        classNames.root || '[&_.slick-arrow]_pt-[calc((100%_-_96px)_/_6_/_384_*_283_-_20px)]',
        classes.root,
      )}
    >
      <Slider
        dots={!!isMobile}
        infinite={false}
        arrows={!isMobile}
        slidesToShow={isMobile ? 2 : slidesToShow || 6}
        slidesToScroll={isMobile ? 2 : 3}
        nextArrow={<SliderArrow />}
        prevArrow={<SliderArrow />}
      >
        {products?.map(product => {
          return (
            <div
              className={classes.itemContainer}
              key={product.id}
            >
              <GalleryItem
                key={product.id}
                item={product}
                hideProductName={hideProductName}
                showCustomizeOptions={showCustomizeOptions}
                showRating={false}
                classes={{
                  name: 'text-[17px] leading-6',
                  price: 'text-[15px] leading-5',
                  imageLink: 'lg_mb-2.5',
                  priceWrapper: 'mt-1.5',
                }}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

const SliderArrow = ({ currentSlide, slideCount, children, ...props }) => {
  const isSlideNext = props.className?.includes('slick-next');

  return (
    <div {...props}>
      <div
        className={clsx(
          'pointer-events-auto flex h-10 w-8 cursor-pointer items-center justify-center bg-white/50',
          isSlideNext && 'rotate-180',
        )}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='12'
          height='22'
          fill='none'
          viewBox='0 0 12 22'
        >
          <path
            stroke='#80583F'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M10.91 1L1.68 11l9.23 10'
          />
          <path
            stroke='#000'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeOpacity='0.2'
            strokeWidth='2'
            d='M10.91 1L1.68 11l9.23 10'
          />
        </svg>
      </div>
    </div>
  );
};

export default RelatedProducts;
